/**
 * Returns the canonical share URL for the current page.
 *
 * Always uses https://zakat.international as the origin, regardless of
 * whether the user is on the preview/dev environment or production.
 * This prevents share buttons and QR codes from leaking the
 * `*.preview.emergentagent.com` URL to social platforms, WhatsApp,
 * Telegram, and printed QR posters.
 *
 * Preserves the current path + any extra query params caller wants
 * (e.g. country + language locking via `?country=AE&lang=ar`).
 *
 * Usage:
 *   canonicalUrl()                                  // current path on zakat.international
 *   canonicalUrl({ country: 'AE', lang: 'ar' })     // adds locked params
 *   canonicalUrl({}, '/inheritance')                // override path
 */
export const CANONICAL_ORIGIN = 'https://zakat.international';

export const canonicalUrl = (extraParams = {}, overridePath = null) => {
  let path = overridePath;
  let existingSearch = '';

  if (path == null && typeof window !== 'undefined' && window.location) {
    path = window.location.pathname || '/';
    existingSearch = window.location.search || '';
  }
  path = path || '/';

  // Merge existing query params with extras (extras win on conflict)
  const params = new URLSearchParams(existingSearch);
  Object.entries(extraParams || {}).forEach(([k, v]) => {
    if (v != null && v !== '') params.set(k, String(v));
  });

  const qs = params.toString();
  return `${CANONICAL_ORIGIN}${path}${qs ? `?${qs}` : ''}`;
};

export default canonicalUrl;
